import "./refinementsSearchFilter.html";
import { BaseComponent } from "../../Core/BaseComponent";
import * as angular from "angular";
import { Binding } from "../../Utils/AngularBindings";
import "./refinementsSearchFilter.less";
import "./refinementsSearchFilter.controller";
export class RefinementsSearchFilterComponent extends BaseComponent {
  constructor() {
    super(
      "Rhinestone.RefinementsSearchFilterController",
      "/templates/search/RefinementsSearchFilter/RefinementsSearchFilter"
    );
    this.bindings = {
      allRefinements: Binding.oneWay,
      refinements: Binding.oneWay,
      criteria: Binding.oneWay,
      color: Binding.valueInput,
      icon: Binding.valueInput,
      onCriteriaChanged: Binding.outputEvent,
      onLoaded: Binding.outputEvent,
      onViewChanged: Binding.outputEvent
    };
  }
}

angular
  .module("PortalApp")
  .component(
    "rhRefinementsSearchFilter",
    new RefinementsSearchFilterComponent()
  );
